import {event} from '../modules/event';
import {cityMap} from '../modules/cityMap';

class ChooseCitySwitch {
    constructor(wrapper) {
        this._createElements(wrapper);
        this._addEvents();
    }

    _createElements(wrapper){
        this.wrapper = wrapper;
        this.nav = wrapper.querySelector('[data-ChooseCitySwitch-nav]');
        this.btnAll = this.nav.querySelectorAll('[data-ChooseCitySwitch-btn]');
        /* TODO */
        this.line2 = document.querySelector('.contact_line2');
        this.chooseCity = this.line2.querySelector('.chooseCity');
        this.frame = this.chooseCity.querySelector('[data-js="frame"]');
    }

    /*
     * в любом случае при клике создаем карту, ибо всего два пункта меню
     * Если будет больше - надо будет создавать при клике на соотв пункт
     * */

    _createAdditionally(){
        var self = parent = this,
            param = JSON.parse(this.wrapper.getAttribute('data-param')),
            l = this.btnAll.length,
            i = 0;

        //
        for(i; i<l; i++){
            var name = this.btnAll[i].getAttribute('data-ChooseCitySwitch-btn');
            this.btnAll[i].frame = this.wrapper.querySelector('[data-ChooseCitySwitch-frame="'+ name +'"]');

            if(name === 'map'){
                var wrapper = this.btnAll[i].frame;

                cityMap(wrapper, param, function(map){
                    //console.log(map);
                });
            }
        }
    }

    _addEvents(){
        var self = this, l = this.btnAll.length, i = 0;

        for(i; i<l; i++){
            this.btnAll[i].onclick = function(){
                self._showItem.call(self, this);
                return false;
            }
        }
    }

    _showItem(btn){
        if(btn.className.indexOf('js-active') !== -1) return false;
        if(!btn.frame) this._createAdditionally();
        this._addActive(btn);
        this.line2.scrollTop = 0;
        this._changeHeight();
    }

    _addActive(btn){
        var l = this.btnAll.length, i = 0;

        for(i; i<l; i++){
            if(this.btnAll[i] === btn) {
                this.btnAll[i].className = this.btnAll[i].className + ' js-active';
                this.btnAll[i].frame.className = this.btnAll[i].frame.className + ' js-active';
            }
            else if (this.btnAll[i].className.indexOf('js-active') !== -1) {
                this.btnAll[i].className = this.btnAll[i].className.replace(' js-active', '');
                this.btnAll[i].frame.className = this.btnAll[i].frame.className.replace(' js-active', '');
            }
        }
    }
    _changeHeight(){
        var h = this.frame.getBoundingClientRect().height;
        this.chooseCity.style.height = h + 'px';
    }
}

export {ChooseCitySwitch};